import * as socketio from '../plugins/socketio/socketio';

export const addEventListener = {
  methods: {
    addEventListener(eventType, eventCallback) {
      socketio.addEventListener({
        type: eventType,
        callback: eventCallback
      });
    }
  }
};
